import React, { useEffect, useState } from 'react';

const Argitech1 = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [showVideo, setShowVideo] = useState(false); // State to control video visibility

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handlePlayClick = () => {
    setShowVideo(true); // Show video when play icon is clicked
  };

  const closeVideo = () => {
    setShowVideo(false); // Close video and return to image
  };

  return (
    <div className='bg-white'>
      <div className='px-4 md:px-40 pt-3'>
        <h1 className="text-[14px] md:text-[36px] font-bold mt-3 text-[#FDBD26]">AgriTech</h1>
        <h1 className="text-[12px] md:text-[32px] font-bold mb-4 text-black">Revolutionizing Agriculture with Digital solutions</h1>

        <div className="relative w-full overflow-hidden rounded-lg bg-white">
          <div className="relative w-full rounded-lg">
            {isLoading && !showVideo && (
              <div className="absolute inset-0 flex items-center justify-center bg-gray-100 z-10">
                <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-[#742B3E] border-solid"></div>
              </div>
            )}

            {/* Image fallback, shown when video is not playing */}
            {!showVideo ? (
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744553589/image_h7nzkt.png"
                alt="Securing Agriculture in Namibia"
                className={`w-full md:h-[622px] object-cover rounded-lg transition-opacity duration-500 ${isLoading ? 'opacity-0' : 'opacity-100'}`}
                onLoad={() => setIsLoading(false)}
              />
            ) : (
              // Video modal overlay
              <div className="absolute inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75">
                <video
                  src="https://res.cloudinary.com/dzngpgki4/video/upload/v1744504626/videoplayback_hwr8ru.mp4"
                  controls
                  autoPlay
                  className="w-full md:w-[80%] md:h-[80%] object-cover rounded-lg"
                />
                <button
                  onClick={closeVideo} // Close video when user clicks 'close'
                  className="absolute top-4 right-4 text-white font-bold text-xl"
                >
                  X
                </button>
              </div>
            )}

            {/* Play icon */}
            {!showVideo && (
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743776596/image_1502_utmsek.png"
                alt="Play"
                className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[40px] h-[40px] md:w-[133px] md:h-[133px] z-10 cursor-pointer"
                onClick={handlePlayClick} // Trigger video display
              />
            )}

            {!isLoading && !showVideo && (
              <div className="absolute bottom-2 md:bottom-6 md:left-0 w-full px-4">
                <h2 className="text-white text-[12px] md:text-[24px] font-bold mb-2">FOOD SECURITY</h2>
                <h2 className="text-white text-[14px] md:text-[40px] font-bold -mt-3" style={{lineHeight:'1.20'}}>Innovation for Sustainable  <br/> Future </h2>
              </div>
            )}
          </div>
        </div>

        {/* Content Section */}
        <div className='px-1'>
          <div className="mt-5 max-w-screen-xl w-full">
            <h3 className="text-black font-normal text-[14px] md:text-[30px]">April 13, 2025</h3>
            <div className="flex items-center gap-6 md:gap-8 text-[13px] md:text-[30px] font-normal text-black">
              <p>Story by Editorial team</p>
              <div className="flex items-center gap-2 text-[#155528]">
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743893169/Time_progress_light_ecbt3q.png"
                  alt="Clock"
                  className="h-6 w-6 md:h-8 md:w-8"
                />
                <p>2 Minutes read</p>
              </div>
            </div>
          </div>

          <h3 className="text-black font-bold text-[14px] md:text-[41px] mt-3 md:mt-5">
            Transforming Namibia's Agriculture: Embracing Innovation for a Sustainable Future
          </h3>

          {/* Main Text Section */}
          <div className="md:mt-5 mt-2 md:space-y-10 space-y-5">
            <p className="text-[12px] md:text-[40px] text-black font-normal">
              Netumbo Nandi-Ndaitwah was inaugurated as Namibia's first female president on March 21, 2025. Her inaugural speech addressed key issues such as economic diversification, job creation, and good governance.
              war against South African forces that lasted more than 20 years.
            </p>

            <p className="text-[12px] md:text-[40px] text-black font-normal">
              “The task facing me as the fifth president of the Republic of Namibia is to preserve the gains of our independence on all fronts and to ensure that the unfinished agenda of <strong>economic and social advancement of our people</strong> is carried forward with vigor and determination to bring about shared, balanced prosperity for all,”
            </p>

            <p className="text-[12px] md:text-[40px] text-black font-normal">
              <strong>"We are going to increase investments in the agriculture </strong>sector to increase output and meet domestic food requirements,"   Nandi-Ndaitwah said in her inaugural speech after being sworn in as president.
              She also committed to diversifying the economy, enabling citizens to   <strong>"derive maximum benefits from our country's natural resources, through value addition".</strong>
            </p>
            <div className='md:h-40 h-10'></div>
          </div>
        </div>
      </div>

      {/* Add the video tag at the end of the JSX */}
      {showVideo && (
        <div className="absolute inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75">
          <video
            src="https://res.cloudinary.com/dzngpgki4/video/upload/v1744504626/videoplayback_hwr8ru.mp4"
            controls
            autoPlay
            className="w-full md:w-[80%] md:h-[80%] object-cover rounded-lg"
          />
          <button
            onClick={closeVideo} // Close video when user clicks 'close'
            className="absolute top-4 right-4 text-white font-bold text-xl"
          >
            X
          </button>
        </div>
      )}
    </div>
  );
};

export default Argitech1;
